import { defineStore } from 'pinia'

//Setup store
export const useOnlineStore = defineStore('online', {
    state: () => ({
        online: navigator.onLine,
        sentNoConnectionMessage: false,
    }),
})